export const ACTIVE_NAVIGATION = {
    HOME: 'Home',
    CUSTOMER_MY_ORDERS: 'Customer My Orders',
    ASSET: 'Asset'
}